// src/features/media/components/VideoHeader.tsx

import { Group, Stack, Text, Anchor } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { Link } from '@tanstack/react-router';
import { MediaStatusBadge } from './MediaStatusBadge';
import { MediaUtils } from '../MediaUtils';
import { VideoActionsGroup } from './VideoActionsGroup';
import type { VideoViewData } from '@/lib/types/Media';

interface VideoHeaderProps {
  video: VideoViewData;
  displayId: string;
}

export function VideoHeader({ video, displayId }: VideoHeaderProps) {
  const media = video.media;

  return (
    <Stack gap="xs">
      <Anchor component={Link} to="/videos" size="sm" c="dimmed">
        <Group gap={4}>
          <IconArrowLeft size={14} />
          Back to Videos
        </Group>
      </Anchor>

      <Group justify="space-between" align="flex-start">
        <Stack gap={4}>
          <Text fw={700} size="xl">{media.title}</Text>
          <Group gap="sm">
            <Text size="sm" c="dimmed">ID: {displayId}</Text>
            <Text size="sm" c="dimmed">·</Text>
            <MediaStatusBadge status={media.mediaStatusType} state={media.mediaStateType} />
            {media.duration > 0 && (
              <>
                <Text size="sm" c="dimmed">·</Text>
                <Text size="sm" c="dimmed">{MediaUtils.formatDuration(media.duration)}</Text>
              </>
            )}
          </Group>
        </Stack>

        <VideoActionsGroup video={video} />
      </Group>
    </Stack>
  );
}
